import React, { createContext, useContext, ReactNode } from 'react';
import { DesignSystemConfig } from '../../../types/config';

const ConfigContext = createContext<DesignSystemConfig | undefined>(undefined);

export const DesignSystemProvider: React.FC<{ config: DesignSystemConfig; children: ReactNode }> = ({ config, children }) => {
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

export const useConfig = (): DesignSystemConfig => {
  const config = useContext(ConfigContext);
  return config || {};
};